import {
  attachRentalPortalListingPhotos,
  getRentalPortalListing,
  updateRentalPortalListingPhoto,
} from '../../../api'
import { getListingProfilePreparedData } from '../../RentalPortalListing'

import {
  getIsPhotoPersisted,
  getPhotoCoverToSave,
  getPhotoFileId,
  getPhotoMoves,
  getPhotosAttachPayload,
  getUnpersistedPhotos,
  toPhotoFormValues,
} from './RentalPortalPhotoGallery.utils'

async function moveListingPhotos({ listingId, moves }) {
  for (const { fileId, position } of moves) {
    await updateRentalPortalListingPhoto({
      data: { position },
      fileId,
      id: listingId,
    })
  }
}

export async function saveRentalPortalListingPhotos({
  listingId,
  photos,
  savedPhotos,
}) {
  const persistedFileIds = photos
    .filter(getIsPhotoPersisted)
    .map(getPhotoFileId)

  const remainingSavedPhotos = savedPhotos.filter(photo =>
    persistedFileIds.includes(getPhotoFileId(photo))
  )

  const moves = getPhotoMoves({
    currentFileIds: remainingSavedPhotos.map(getPhotoFileId),
    targetFileIds: persistedFileIds,
  })

  await moveListingPhotos({ listingId, moves })

  const attachPayload = getPhotosAttachPayload(photos)

  if (attachPayload.length > 0) {
    await attachRentalPortalListingPhotos({
      id: listingId,
      photos: attachPayload,
    })
  }

  const cover = getPhotoCoverToSave({
    photos,
    savedPhotos: remainingSavedPhotos,
  })

  if (cover) {
    await updateRentalPortalListingPhoto({
      data: { is_cover: true },
      fileId: getPhotoFileId(cover),
      id: listingId,
    })
  }

  return moves.length > 0 || attachPayload.length > 0 || Boolean(cover)
}

export async function getRentalPortalListingPhotosState({ listingId, photos }) {
  const { data } = await getRentalPortalListing(listingId)

  const savedPhotos = toPhotoFormValues(
    getListingProfilePreparedData(data).photos
  )

  const savedFileIds = savedPhotos.map(getPhotoFileId)

  return {
    photos: [
      ...savedPhotos,
      ...getUnpersistedPhotos(photos).filter(
        photo => !savedFileIds.includes(getPhotoFileId(photo))
      ),
    ],
    savedPhotos,
    version: data.version,
  }
}
